import { formatMoney } from '@travelata-libs/utils';

const PRICE_PREFIX = 'от';
const PRICE_SUFFIX = 'р./чел.';

const GROUPING_SPACE_RE = /\s/g;
const NBSP = ' ';

export function formatMinPrice(minPrice: number | null): string {
  if (minPrice === null || !Number.isFinite(minPrice) || minPrice <= 0) {
    return '';
  }

  const amount = formatMoney(minPrice, null).replace(GROUPING_SPACE_RE, NBSP);

  return `${PRICE_PREFIX} ${amount} ${PRICE_SUFFIX}`;
}
